module.exports = __webpack_public_path__ + "static/media/ericSharfstein.aed4f33d.png";